module.exports = __webpack_public_path__ + "img/LandIsland.6bd65e8e.png";